 <template>
   <div :class="['d-flex flex-column align-items-center justify-content-between rounded count-down-container',alertClass()]">
     <div class="d-flex flex-row align-items-center justify-content-center pt-1">
       <font-awesome-icon
           style="font-size:13px" icon="exclamation-circle" class="text-secondary"
           v-b-tooltip.hover.right="$t('simple.account_active_until', { date:deactive })" />
       <span class="p-1 count-down-text">{{$t('simple.account_active_until',{date:''})}}</span>
     </div>
     <div class="d-flex flex-row align-items-center justify-content-center pb-1">
       <span class="m-0 count-down-text">{{ formattedTime}}</span>
     </div>
   </div>
  </template>
<script>

export default {
  props: {
    days: { type: Number, required: true },
    hours: { type: Number, required: true },
    minutes: { type: Number, required: true },
    seconds: { type: Number, required: true },
    deactive: { type: String, required: true },
  },
    mounted() {
      this.$nextTick(() => {
        this.startCountdown();
      });
    },

    beforeDestroy() {
      clearInterval(this.timer);
    },

    data: function () {
        return {
          totalSeconds:
              this.days * 86400 + this.hours * 3600 + this.minutes * 60 + this.seconds,
          remaining: { days: 0, hours: 0, minutes: 0, seconds: 0 },
          timer: null,
        }
    },

  computed: {
    formattedTime() {
      const d = String(this.remaining.days).padStart(2, "0");
      const h = String(this.remaining.hours).padStart(2, "0");
      const m = String(this.remaining.minutes).padStart(2, "0");
      const s = String(this.remaining.seconds).padStart(2, "0");
      return `${d} : ${h} : ${m} : ${s}`;
    },
  },
    methods: {
      alertClass() {
        if (this.remaining.days < 1) {
          return "alert-danger";
        } else if (this.remaining.days < 7) {
          return "alert-warning";
        }
        return "alert-success";
      },
      updateRemaining() {
        let t = this.totalSeconds;
        this.remaining = {
          days: Math.floor(t / 86400),
          hours: Math.floor((t % 86400) / 3600),
          minutes: Math.floor((t % 3600) / 60),
          seconds: t % 60,
        };
      },
      startCountdown() {
        this.updateRemaining();
        this.timer = setInterval(() => {
          if (this.totalSeconds > 0) {
            this.totalSeconds--;
            this.updateRemaining();
          }
        }, 1000);
      },
    },
}

</script>